module.exports = __webpack_public_path__ + "static/first_user_image5-62307c7227d8fe255704e00ccc38d23c.jpg";